export default class MeterNumberDiagramHelp{
  _tree_list=[];
  _top_list=[];
  constructor(list=[]) {
    this._tree_list=MeterNumberDiagramHelp.getTreeAll("",list);

  }

  getTreeList(list=[]){
    if(list.length){
      this._tree_list=MeterNumberDiagramHelp.getTreeAll("",list);
    }
    return this._tree_list;
  }

  static random(){
    return (new Date()).getTime()+"_"+(Math.floor(Math.random()*10000))
  }

  static getTree(parent_number,list=[]){
    return list.filter(re=>re.parent_number===parent_number).map(ret=>{
      if(!ret.id){
        ret.id=MeterNumberDiagramHelp.random()
      }
      return {
        id:ret.id+'',
        name:ret.name,
        number: ret.number,
        parent_number: ret.parent_number,
        house_name: ret.house_name,
        energy: ret.meter_energy_name,
        count: list.filter(res=>res.parent_number===ret.number).length,
      }
    })
  }
  static getTreeAll(parent_number,list=[]){
    let root_list=MeterNumberDiagramHelp.getTree(parent_number,list)
    root_list=root_list.map(re=>{
      let ls=MeterNumberDiagramHelp.getTree(re.number,list);
      if(ls.length>0){
        re.children=MeterNumberDiagramHelp.getTreeAll(re.number,list);
      }
      return re;
    })
    return root_list
  }

  getTopList(){
    return this._tree_list.map(ret=>{
      if(!ret.id){
        ret.id=MeterNumberDiagramHelp.random()
      }
      return {
        id:ret.id+'',
        name:ret.name,
        number: ret.number,
        parent_number: ret.parent_number,
        house_name: ret.house_name,
        energy: ret.energy,
        count: ret.count,
      }
    })
  }

  static getTreeData(tree_list=[]){
    let list=[];
    tree_list.forEach(re=> {
      list.push(re);
      if (re.children) {
        list=list.concat(...MeterNumberDiagramHelp.getTreeData(re.children));
      }
    });
    return list;
  }

  /**
   * 对比excel数据和tree数据，返回差异数据
   * @param excel_list
   * @param tree_list
   */
  static getDiffData(excel_list=[],tree_list=[]){
    let list=[];
    let excel_list_number=excel_list.map(re=>re.number);
    let tree_list_number=tree_list.map(re=>re.number);
    let diff_list=excel_list_number.filter(re=>!tree_list_number.includes(re));
    diff_list.forEach(re=>{
      let obj=excel_list.find(res=>res.number===re);
      list.push({
        name:obj.name,
        number:obj.number,
        parent_number: obj.parent_number,
        is_parent_number:excel_list_number.includes(obj.parent_number),
        house_name:obj.house_name,
        energy:obj.meter_energy_name,
        count:0,
      })
    });
    return list;
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/components/meter/components/common/MeterNumberDiagramHelp.js